import { CATEGORY_PLANS_ID_PAQUETE_INTERNET_POSPAGO, CATEGORY_PLANS_ID_PAQUETE_INTERNET_POSPAGO_MIXTO, CATEGORY_PLANS_ID_PAQUETE_MAS_DATOS, CATEGORY_PLANS_ID_PAQUETE_MAS_DATOS_MIXTO } from "../../../../constants"

export function calculateProductId(idPlan, amount, typePlan, idExternal) {
    if(typePlan == 3){
        switch (amount) {
            case 10:
                return 399
            case 20:
                return 248
            case 30:
                return 251
            case 50:
                return 253
            case 80:
                return 255
            case 100:
                return 257
            case 150:
                return 259
            case 200:
                return 261
            case 300:
                return 263
            case 500:
                return 265
            default:
              return false
        }
    }

    if(typePlan == 4){
        switch (amount) {
            case 10:
                return 397
            case 20:
                return 249
            case 30:
                return 250
            case 50:
                return 252
            case 80:
                return 254
            case 100:
                return 256
            case 150:
                return 258
            case 200:
                return 260
            case 300:
                return 262
            case 500:
                return 264
            case 500:
                return 264
            case 270:
                return 486
            case 400:
                return 487
            case 1200:
                return idExternal
            case 2400:
                return idExternal
            default:
              return false
        }
    }

    if(typePlan == 8) {
        switch(amount) {
            case 15:
                return 385
            case 10:
                return 386
			case 25:
				return 495
            default:
                return idExternal
        }
    }

    if(typePlan == CATEGORY_PLANS_ID_PAQUETE_MAS_DATOS) {
        return idExternal;
    }
    if(typePlan == CATEGORY_PLANS_ID_PAQUETE_MAS_DATOS_MIXTO) {
        return idExternal;
    }
    if(typePlan == CATEGORY_PLANS_ID_PAQUETE_INTERNET_POSPAGO_MIXTO) {
        return idExternal;
    }
    if(typePlan == CATEGORY_PLANS_ID_PAQUETE_INTERNET_POSPAGO) {
        return idExternal;
    }
    
}
